export const reports = {
  // Dashboard
  dashboard: {
    title: '報表儀表板',
    subtitle: '訪問您的電動車充電網絡的綜合報表和分析',
    noReports: '沒有可用的報表',
    noReportsDesc: '您沒有權限訪問任何報表',
  },

  // Categories
  categories: {
    financial: '財務報表',
    financialDesc: '收入追蹤、交易分析和賬單報表',
    operational: '營運報表',
    operationalDesc: '充電時段分析、使用率指標和能源消耗',
    vendor: '供應商報表',
    vendorDesc: '跨供應商性能比較和站點分析',
  },

  // Revenue Analysis Report
  revenue: {
    title: '收入分析',
    description: '按時間段追蹤收入趨勢，包含站點/充電器/供應商細分',
    subtitle: '收入表現和財務指標',
  },

  // Transaction Volume Report
  transactions: {
    title: '交易量',
    description: '分析交易模式和支付方式',
    subtitle: '交易分析和支付趨勢',
  },

  // Transaction (singular for labels)
  transaction: {
    title: '交易',
  },

  // Session Analytics Report
  sessions: {
    title: '充電時段分析',
    description: '深入分析充電時段模式和使用情況',
    subtitle: '詳細的充電時段洞察',
  },

  // Charger Utilization Report
  utilization: {
    title: '充電器使用率',
    description: '追蹤充電器使用效率和正常運行時間',
    subtitle: '充電器性能和可用性指標',
  },

  // Energy Consumption Report
  energy: {
    title: '能源消耗',
    description: '追蹤能源輸送模式和成本細分',
    subtitle: '能源使用和成本分析',
    roundingNote: '注意：實際帳單成本為各筆實際充電帳單金額的加總。由於每筆帳單金額均會各自四捨五入至最小貨幣單位，將總能源乘以每度平均成本所得的數值，可能與實際帳單成本存在輕微的小數差異。',
    energyByWindowTitle: '各充電時段能源佔比',
  },

  // Peak Usage Report
  peak: {
    title: '峰值使用分析',
    description: '識別峰值使用模式以進行容量規劃',
    subtitle: '負載分佈和峰值需求分析',
  },

  // Vendor Performance Report
  vendorPerformance: {
    title: '供應商表現',
    description: '比較所有供應商的性能指標',
    subtitle: '跨供應商性能比較',
  },

  // Site Comparison Report
  siteComparison: {
    title: '站點比較',
    description: '比較供應商的所有站點',
    subtitle: '站點級性能分析',
  },

  // User Activity Report
  userActivity: {
    title: '用戶活動',
    description: '按用戶（App、RFID、Vendor API、後台）匯總各站點的充電活動——時段數、時長、能源、收入，以及用於跟進的聯絡資料。',
    searchLabel: '搜尋用戶（姓名／電話）',
    searchPlaceholder: '輸入姓名或電話',
    userTypesLabel: '用戶類型',
    userTypeAll: '全部',
    userType: {
      app: 'App',
      rfid: 'RFID',
      vendor_api: 'Vendor API',
      backend: '後台',
    },
    empty: '沒有符合目前篩選條件的用戶。',
    exportTruncated: '匯出已截斷至首 %{count} 行。請縮小日期範圍以顯示更多資料。',
    exportFailed: '匯出失敗——請查看主控台。',
    kpi: {
      totalUsers: '用戶總數',
      totalUsersSubtitle: '活躍用戶',
      totalSessions: '充電時段總數',
      chargedSessions: '已充電時段',
      avgPerUser: '每用戶平均 %{count}',
      totalEnergy: '總能源',
      totalRevenue: '總收入',
      avgRevenuePerUser: '每用戶平均 HKD %{amount}',
    },
    fields: {
      phone: '電話',
      email: '電郵',
      carPlate: '車牌',
      sessions: '充電時段',
      duration: '時長',
      energy: '能源',
      lastSession: '最近時段',
    },
    table: {
      user: '用戶',
      type: '類型',
      contact: '聯絡資料',
      sessions: '充電時段',
      chargedSessions: '已充電時段',
      duration: '時長',
      energy: '能源 (kWh)',
      revenue: '收入 (HKD)',
      sites: '站點',
      lastSession: '最近時段',
    },
  },

  // Filters
  filters: {
    title: '篩選條件',
    startDate: '開始日期',
    endDate: '結束日期',
    dateRange: '日期範圍',
    site: '站點',
    allSites: '所有站點',
    vendor: '供應商',
    allVendors: '所有供應商',
    charger: '充電器',
    allChargers: '所有充電器',
    groupBy: '分組方式',
    custom: '自訂',
  },

  // Group By Options
  groupBy: {
    day: '天',
    week: '周',
    month: '月',
    site: '站點',
    charger: '充電器',
    method: '啟動方式',
  },

  // Tabs
  tabs: {
    charts: '圖表',
    dataTable: '數據表',
    timeSeries: '時間序列',
  },

  // Actions
  actions: {
    refresh: '刷新',
    export: '導出',
    viewDetails: '查看詳情',
    downloadReport: '下載報表',
  },

  // Export
  export: {
    csv: '導出 CSV',
    excel: '導出 Excel',
    pdf: '導出 PDF',
    csvSuccess: 'CSV 匯出成功',
    excelSuccess: 'Excel 匯出成功',
    csvFailed: 'CSV 匯出失敗——請查看主控台。',
    excelFailed: 'Excel 匯出失敗——請查看主控台。',
    noData: '沒有可匯出的資料——請調整篩選條件後再試。',
  },

  // Excel Export
  excel: {
    generated: '產生於',
  },

  // Errors
  errors: {
    loadFailed: '無法加載報表數據',
    exportFailed: '無法導出報表',
    noData: '所選期間沒有可用數據',
    invalidDateRange: '選擇的日期範圍無效',
  },


  // KPI Cards
  kpi: {
    totalRevenue: '總收入',
    totalSessions: '總時段數',
    chargedSessions: '已充電時段',
    chargedSessionsTooltip: '實際有輸出電量的充電時段(kWh > 0)。車輛插電但未輸出電量的時段(例如:立即拔線或故障)不會計入。',
    totalSessionsTooltip: '所選日期範圍內所有已歸檔的充電時段,包括未輸出電量的時段。',
    avgRevenuePerSession: '每時段平均收入',
    totalEnergy: '總能源',
    totalEnergyKwh: '總能源 (kWh)',
    totalEnergyCost: '總能源成本',
    totalIdleCost: '總閒置費用',
    totalCost: '總成本',
    totalTransactions: '總交易數',
    totalValue: '總價值',
    totalAmount: '總金額',
    successRate: '成功率',
    avgTransactionAmount: '平均交易金額',
    completedTransactions: '已完成',
    completedCount: '已完成數量',
    failedTransactions: '失敗',
    utilizationRate: '使用率',
    uptimeRate: '正常運行率',
    sessionsPerDay: '每天時段數',
    totalChargers: '充電器總數',
    availableChargers: '可用',
    offlineChargers: '離線/故障',
    avgDuration: '平均時長',
    avgEnergy: '平均能源',
    completionRate: '完成率',
    avgCostPerKwh: '每度平均成本',
    theoreticalCost: '理論成本',
    roundingVariance: '進位差異',
    actualBilledCost: '實際帳單成本',
    peakEnergyPercent: '峰值能源 %',
    peakHour: '峰值時段',
    peakHourSessions: '峰值時段數',
    peakConcurrentSessions: '峰值並發時段',
    peakLoad: '峰值負載 (kW)',
    totalVendors: '供應商總數',
    avgUptime: '平均正常運行率',
    totalSites: '站點總數',
    activeSites: '活躍站點',
    avgUtilization: '平均使用率',
    bestPerformer: '最佳表現者',
  },

  // Chart Titles
  charts: {
    revenueOverTime: '收入隨時間變化',
    revenueBySite: '按站點收入（前10名）',
    revenueByMethod: '按啟動方式收入',
    transactionVolumeOverTime: '交易量隨時間變化',
    transactionsByType: '按類型交易',
    transactionsByMethod: '按支付方式交易',
    paymentMethodDistribution: '支付方式分佈',
    dailyTransactionVolume: '每日交易量',
    sessionsOverTime: '時段隨時間變化',
    sessionsBySite: '按站點時段',
    sessionsByMethod: '按啟動方式時段',
    hourlyUsagePattern: '每小時使用模式',
    utilizationByCharger: '按充電器使用率',
    uptimeTrends: '正常運行時間趨勢',
    utilizationTrends: '使用率趨勢',
    statusDistribution: '充電器狀態分佈',
    energyOverTime: '能源輸送隨時間變化',
    energyByTimeWindow: '按時段能源',
    costBreakdown: '成本細分',
    hourlyDistribution: '每小時分佈',
    peakConcurrentSessions: '峰值並發時段',
    vendorComparison: '供應商比較',
    sitePerformance: '站點表現',
    vendorSessions: '按供應商時段',
    vendorRevenue: '按供應商收入',
    revenueTrends: '供應商收入趨勢',
    topSitesSessions: '按時段數排名站點',
    topSitesRevenue: '按收入排名站點',
  },

  // Time Periods
  periods: {
    today: '今天',
    yesterday: '昨天',
    last7Days: '過去7天',
    last30Days: '過去30天',
    thisMonth: '本月',
    lastMonth: '上月',
    custom: '自定義範圍',
  },

  // Initiation Methods
  methods: {
    app: '手機應用',
    rfid: 'RFID卡',
    admin: '管理員',
    ocpp: 'OCPP',
    vendorApi: '供應商API',
  },

  // Transaction Types
  transactionTypes: {
    topup: '充值',
    payment: '付款',
    refund: '退款',
    credit: '積分',
  },

  // Payment Methods
  paymentMethods: {
    wallet: '錢包',
    credit_card: '信用卡',
    rfid_billing: 'RFID 帳單',
  },

  // Transaction Statuses
  statuses: {
    completed: '已完成',
    pending: '待處理',
    failed: '失敗',
  },

  // Loading and Empty States
  loading: '正在加載報表數據...',
  noData: '所選期間沒有可用數據',
  selectDateRange: '請選擇日期範圍以查看報表',

  // Table View
  dailyBreakdown: '每日明細',
  summary: '摘要',
  days: '天',
  table: {
    date: '日期',
    month: '月份',
    hour: '小時',
    revenue: '收入',
    sessions: '時段數',
    avgPerSession: '每時段平均',
    avgDuration: '平均時長 (分鐘)',
    energyKwh: '能源 (kWh)',
    energyCost: '能源成本',
    idleCost: '閒置費用',
    completionRate: '完成率 %',
    chargingHours: '充電時數',
    cost: '成本',
    avgCostPerKwh: '每度平均成本',
    count: '數量',
    transactionCount: '數量',
    completed: '已完成',
    successRate: '成功率',
    amount: '金額',
    total: '總計',
    average: '平均',
    vendor: '供應商',
    type: '類型',
    uptime: '正常運行率 %',
    sites: '站點',
    chargers: '充電器',
    site: '站點',
    location: '位置',
    utilization: '使用率 %',
    availability: '可用率 %',
    charger: '充電器',
    sessionsPerDay: '每日時段數',
    status: '狀態',
  },

  // Other labels
  chargerDetails: '充電器詳情',
  vendorDetails: '詳細供應商指標',
  siteDetails: '詳細站點指標',

  // Hong Kong Locations - Districts and Areas
  locations: {
    // Hong Kong Island Districts
    'central-western': '中西區',
    'central-and-western': '中西區',
    'eastern': '東區',
    'southern': '南區',
    'wan-chai': '灣仔區',

    // Kowloon Districts
    'kowloon-city': '九龍城區',
    'yau-tsim-mong': '油尖旺區',
    'sham-shui-po': '深水埗區',
    'wong-tai-sin': '黃大仙區',
    'kwun-tong': '觀塘區',

    // New Territories Districts
    'tai-po': '大埔區',
    'yuen-long': '元朗區',
    'tuen-mun': '屯門區',
    'north': '北區',
    'sai-kung': '西貢區',
    'sha-tin': '沙田區',
    'tsuen-wan': '荃灣區',
    'kwai-tsing': '葵青區',
    'islands': '離島區',

    // Popular Areas - Hong Kong Island
    'central': '中環',
    'admiralty': '金鐘',
    'sheung-wan': '上環',
    'mid-levels': '半山',
    'peak': '山頂',
    'causeway-bay': '銅鑼灣',
    'north-point': '北角',
    'quarry-bay': '鰂魚涌',
    'shau-kei-wan': '筲箕灣',
    'chai-wan': '柴灣',
    'aberdeen': '香港仔',
    'stanley': '赤柱',
    'repulse-bay': '淺水灣',
    'tin-hau': '天后',
    'fortress-hill': '炮台山',
    'tai-koo': '太古',
    'sai-wan-ho': '西灣河',

    // Popular Areas - Kowloon
    'tsim-sha-tsui': '尖沙咀',
    'jordan': '佐敦',
    'yau-ma-tei': '油麻地',
    'mong-kok': '旺角',
    'prince-edward': '太子',
    'tai-kok-tsui': '大角咀',
    'to-kwa-wan': '土瓜灣',
    'hung-hom': '紅磡',
    'kowloon-bay': '九龍灣',
    'kwun-tong-area': '觀塘',
    'ngau-tau-kok': '牛頭角',
    'diamond-hill': '鑽石山',
    'choi-hung': '彩虹',
    'lok-fu': '樂富',
    'kowloon-tong': '九龍塘',
    'lam-tin': '藍田',
    'yau-tong': '油塘',

    // Popular Areas - New Territories
    'tsing-yi': '青衣',
    'kwai-chung': '葵涌',
    'tsing-lung-tau': '青龍頭',
    'tai-wo-hau': '大窩口',
    'shek-kip-mei': '石硤尾',
    'mei-foo': '美孚',
    'lai-chi-kok': '荔枝角',
    'cheung-sha-wan': '長沙灣',
    'shatin': '沙田',
    'ma-on-shan': '馬鞍山',
    'tai-wai': '大圍',
    'fo-tan': '火炭',
    'tseung-kwan-o': '將軍澳',
    'clear-water-bay': '清水灣',
    'sai-kung-town': '西貢市',
    'fanling': '粉嶺',
    'sheung-shui': '上水',
    'tai-po-market': '大埔墟',
    'tuen-mun-town': '屯門市中心',
    'yuen-long-town': '元朗市中心',
    'tin-shui-wai': '天水圍',
    'tung-chung': '東涌',
    'discovery-bay': '愉景灣',
    'mui-wo': '梅窩',
    'cheung-chau': '長洲',
    'lamma-island': '南丫島',
    'lantau-island': '大嶼山',
  },
};
